import React from "react"
import { Button, Input, Modal, ModalBody } from "reactstrap"

const ModalTemplate = ({ isModalOpen, setIsModalOpen }) => {
  const toggle = () => setIsModalOpen(!isModalOpen)

  return (
    <div>
      <Modal isOpen={isModalOpen} toggle={toggle} centered>
        <ModalBody>
          <h5 className="my-3 text-center">Add new templete</h5>

          <div>
            <label htmlFor="templete-name">Template Name</label>
            <Input type="text" />
          </div>
          <div className="mt-3">
            <label htmlFor="templete-name">Template Name</label>
            <Input type="textarea" />
          </div>
          <div className="d-flex justify-content-end">
            <Button
              color="info"
              style={{
                backgroundColor: "#48b9e2 !important",
                borderColor: "#48b9e2 !important",
              }}
              className="mt-3 fw-medium"
              onClick={() => {}}
            >
              Add
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default ModalTemplate
